export enum TypeAlarmDistribution {
    DYNAMIC = 'dynamic',
    ALL = 'all',
}
